// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2lOmj","productName":"Table_productName__i0uqq"};